import { LocaleContext } from '@/providers/locale-provider'
import { Answer, Question } from '@/types/questions'
import { ChoiceList, ChoiceListTypes, FormCheckbox } from '@lib-components'
import { ChangeEvent, use, ReactElement } from 'react'
import { Control, FieldValues, Controller } from 'react-hook-form'

type CheckboxQuestionProps = {
    question: Question
    name: string
    control: Control<FieldValues, unknown>
    inline: boolean
}

const CheckboxQuestion = ({ question, name, control, inline }: CheckboxQuestionProps): ReactElement => {
    const localeContext = use(LocaleContext)

    return (
        <>
            {localeContext.getLocaleText(question.questionContent.text)}
            <ChoiceList
                type={inline ? ChoiceListTypes.INLINE : ChoiceListTypes.DEFAULT}
                className={`${inline ? 'items-center gap-2' : 'w-full'}`}
            >
                <Controller
                    control={control}
                    name={name}
                    shouldUnregister
                    defaultValue={[]}
                    render={({ field: { onChange, value } }) => (
                        <>
                            {question.questionContent.answers.map((answer: Answer) => (
                                <FormCheckbox
                                    key={answer.id}
                                    name={name}
                                    checked={value.some((existingValue: string) => existingValue === answer.id)}
                                    value={answer.id}
                                    label={localeContext.getLocaleText(answer.text)}
                                    onChange={(internalValue: ChangeEvent<HTMLInputElement>, checked: boolean) => {
                                        if (checked) {
                                            onChange([...value, internalValue.target.value])
                                        } else {
                                            onChange(
                                                value.filter(
                                                    (fieldValue: unknown) => fieldValue !== internalValue.target.value,
                                                ),
                                            )
                                        }
                                    }}
                                    boxed={inline}
                                />
                            ))}
                        </>
                    )}
                />
            </ChoiceList>
        </>
    )
}

export default CheckboxQuestion
